import { render, staticRenderFns } from "./Kemajuan_new.vue?vue&type=template&id=20554c84"
import script from "./Kemajuan_new.vue?vue&type=script&lang=js"
export * from "./Kemajuan_new.vue?vue&type=script&lang=js"
import style0 from "./Kemajuan_new.vue?vue&type=style&index=0&id=20554c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports